<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <main class="scrollable container">
      <h2 :style="{marginBottom: '20px'}">Loans</h2>
      <span
        class="t16"
        :style="{marginBottom: '12px', display: 'block'}"
        >Current loans</span
      >
      <ul :style="{marginBottom: '30px'}">
        <li
          v-for="loan in loans"
          :key="loan.id"
          :style="{}"
        >
          <div
            :style="{
              gap: '8px',
              width: '100%',
              padding: '20px',
              borderRadius: '10px',
              marginBottom: '20px',
              backgroundColor: '#FFF7F2',
            }"
            class="row-center clickable"
          >
            <component :is="PercentageLoanSvg" />
            <span :style="{fontSize: '20px', marginRight: 'auto'}"
              >- {{ loan.amount }} USD</span
            >
            <span
              class="t14"
              :style="{fontWeight: '600', color: 'var(--main-color)'}"
              >Repay →</span
            >
          </div>
          <div
            class="row-center-space-between"
            :style="{marginBottom: '14px'}"
          >
            <span class="t14">Rate</span>
            <h6>{{ loan.rate }}</h6>
          </div>
          <div
            class="row-center-space-between"
            :style="{marginBottom: '14px'}"
          >
            <span class="t14">Period</span>
            <h6>{{ loan.period }} months</h6>
          </div>
          <div
            class="row-center-space-between"
            :style="{marginBottom: '14px'}"
          >
            <span class="t14">Monthly payment</span>
            <h6>{{ loan.monthlyPayment }} USD</h6>
          </div>
          <div class="row-center-space-between">
            <span class="t14">Total paid</span>
            <h6>{{ loan.totalPaid }} USD</h6>
          </div>
        </li>
      </ul>
      <Button
        :title="'+ New Loan'"
        :colorSchema="'secondary'"
        @click="$router.push(routes.OPEN_NEW_LOAN)"
      />
    </main>
  </div>
</template>

<script setup>
import {routes} from '@/routes';
import {useOpacity} from '@/hooks';
import {Button} from '@/components';
import {PercentageLoanSvg} from '@/assets/svg';

const opacity = useOpacity();

const loans = [
  {
    id: 1,
    rate: '13%',
    amount: '1 200.00',
    period: '24',
    monthlyPayment: '1 117.00',
    totalPaid: '26 808.00',
    leftToClose: '20 532.00',
  },
];
</script>
